import './styles/PageLoader.scss';

// Shared Suspense / loading fallback. Replaces the bare "..." text so route
// transitions show a consistent, branded loader.
export default function PageLoader() {
    return (
        <div className="pageLoader" role="status" aria-label="Načítání">
            <span className="spinner" />
        </div>
    );
}
